module.exports = __webpack_public_path__ + "static/media/pieces-with-diff-edges-img.49ea53ca.svg";